import React, { FunctionComponent, useRef } from "react";
import { useTranslation } from "react-i18next";

import { HashLink } from "../../navigation/HashLink";
import { useGetCartContents } from "../../queries/useGetCartContents";
import { useCart } from "../../stores/hooks/useCart";
import { useIsLoggedOn } from "../../stores/hooks/useIsLoggedOn";
import { PrimaryButton, RoundButton } from "../../ui/Button/Button";
import { CartIcon } from "../../ui/icons/CartIcon";
import { PasswordResetDialog } from "../Auth/PasswordResetDialog";
import { SignInDialog, signInHash } from "../Auth/SignInDialog";
import { SignupDialog } from "../Auth/SignupDialog";
import { Calculator } from "../Calculator/Calculator";
import {
  CartPreview,
  useCartDropdownState,
} from "../Cart/CartPreview/CartPreview";
import { NewQuoteModal } from "../Cart/NewQuoteModal/NewQuoteModal";
import { UserButton } from "./UserButton";

export const Actions: FunctionComponent = () => {
  const { t } = useTranslation();
  const isLoggedOn = useIsLoggedOn();
  const cartButtonRef = useRef<HTMLButtonElement>(null);
  const [cartDropdownIsVisible, { show: showCartDropdown }] =
    useCartDropdownState();
  const cart = useCart();
  useGetCartContents(cart?.orderId);
  const count = cart?.orderItemList?.length || 0;

  return (
    <nav className="flex justify-end gap-x-2" id="user-nav">
      {!isLoggedOn && (
        <>
          <HashLink hash={signInHash}>
            <PrimaryButton
              aria-label="openSignInDialog"
              className="tw-sign-in"
              element="a"
              id="sign-in-toggle"
            >
              {t("siteHeader.signIn")}
            </PrimaryButton>
          </HashLink>
          <SignInDialog id="sign-in-dialog" />
          <SignupDialog />
          <PasswordResetDialog id="password-reset-dialog" />
        </>
      )}
      <Calculator />

      {isLoggedOn && <UserButton />}
      <RoundButton
        onClick={(): void => {
          if (!cartDropdownIsVisible) {
            showCartDropdown();
          }
        }}
        aria-label="openCartPreview"
        className="relative transition"
        disabled={cartDropdownIsVisible}
        id="cart-dropdown-button"
        ref={cartButtonRef}
      >
        <CartIcon className="-translate-x-[0.1rem]" />
        {count > 0 && (
          <small className="bg-primary bg-opacity-95 rounded-full p-0.5 text-white text-xs absolute -top-2 -right-2 min-w-[1.6em]">
            {count}
          </small>
        )}
      </RoundButton>
      <CartPreview producerRef={cartButtonRef} />
      <NewQuoteModal />
    </nav>
  );
};
